<div class="animated fadeIn portafolio container-fluid">
    <h1>Portafolio</h1>
    <hr>

    
    <p>Aquí tengo algunos ejemplos de lo que estoy haciendo. Puedes darles click para verlos funcionando.</p>
    <div class="galeria grid">
    <app-loading *ngIf="loading"></app-loading>
      <div class='item animated fadeIn fast' id="item1" *ngFor="let portafolio of portafolio; let i = index">
        <button (click)='verProyecto(i)' (keyup)="verProyecto(i)">
            <img [src]="portafolio.img" class="img1 animated fadeIn" [alt]="portafolio.nombre">
        </button>
      </div>
    </div>
</div>

